import React from 'react';
import PropTypes from 'prop-types';
import trans from 'translate';
import ShowAt from '../../../ShowAt/ShowAt';
import { statusLength } from '../../../../Pages/Champion/ChampionChecker/ChampionOwner/statusMapper';

export default function StepIndex({ stepInfo }) {
  const { stepIndex, statusLength } = stepInfo;
  return (
    <ShowAt at={!!stepIndex}>
      <span>({trans('hpool.step', { from: stepIndex, to: statusLength })})</span>
    </ShowAt>
  );
}

StepIndex.defaultProps = {
  stepInfo: {},
};

StepIndex.propTypes = {
  stepInfo: PropTypes.object,
};
